'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:UserNewCtrl
 * @description
 * # UserNewCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('UserNewCtrl', [
    '$scope', 'User', '$state', '$stateParams', '$rootScope', function ($scope, User, $state, $stateParams, $rootScope) {
    if($stateParams.userId) {
      User.find($stateParams.userId).then(function(response) {
        $scope.userHash = { 'user': response.data.user };
      }, function(error) {
        User.error(error);
      });
    } else {
      $scope.userHash = {
        'user': {
          'name': '',
          'operator_role': false,
          'administrator_role': false,
          'finance_role': false,
          'azure_token': null
        }
      };
    }

    $scope.saveUser = function() {
      User.save($scope.userHash).then(function(response) {
        $scope.userHash = {
          'user': {
            'name': '',
            'operator_role': false,
            'administrator_role': false,
            'finance_role': false,
            'azure_token': null
          }
        };
        // TODO: Toast message se creo con exito
        if($rootScope.userIsAdmin){
          $state.go('app.users.list', {clientId: response.data.user.id});
        }else{
          $state.go('app.users.show_not_admin', {userId: response.data.user.id});
        }
      }, function(error) {
        User.error(error);
      });
    };
  }]);
